import { render, staticRenderFns } from "./app-promo-card.vue?vue&type=template&id=0dde161a&scoped=true&"
import script from "./app-promo-card.vue?vue&type=script&lang=js&"
export * from "./app-promo-card.vue?vue&type=script&lang=js&"
import style0 from "./app-promo-card.vue?vue&type=style&index=0&id=0dde161a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde161a",
  null
  
)

export default component.exports